export const ZENJOB_LOGO_ALT_TEXT = 'Zenjob Pro Logo Purple';

export const CV_BUILDER_STEPS = {
  OVERVIEW: 'overview'
};
